import { compose } from 'underscore';

import withCustomLabelsByUserAndCourse from 'bundles/custom-labels/hoc/withCustomLabelsByUserAndCourse';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';

import { ControlsBar } from './ControlsBar';

const controlsBarComponent = compose(
  discussionsForumsHOC({
    fields: ['link', 'title', 'description', 'lastAnsweredAt', 'forumQuestionCount'],
  }),
  // NOTE: `courseId` is injected by discussionsForumsHOC
  withCustomLabelsByUserAndCourse
)(ControlsBar);

export { controlsBarComponent as ControlsBar };
